<template>
  <div class="text-content">
    <template v-if="isLongContent">
      <tooltip :delay="2000" :max-width="640" placement="top">
        <div class="ms-text">{{ shortContent }}...</div>
        <div slot="content">
          <p class="text-content-tooltip">{{ content }}</p>
        </div>
      </tooltip>
    </template>
    <template v-else>
      {{ content }}
    </template>
  </div>
</template>

<script>
export default {
  props: ['content'],
  computed: {
    shortContent () {
      return this.content.substr(0, 100)
    },
    isLongContent () {
      if (!this.content) return false

      return this.content.length > 100
    }
  }
}
</script>

<style lang="less">
.text-content {
  &-tooltip {
    word-break: break-all;
    font-size: 12px;
  }
}
</style>
